import { Dispatch, SetStateAction, Suspense, useState } from 'react'
import ReactPlayer from 'react-player';

import { IEjercicioItems, IEjercicioRutina } from '../../../../Interfaces/IMisRutinas';
import Series from '../Series/Series';
import Reemplazos from '../Reemplazos/Reemplazos';
import ModalInfoTriseries from '../../../../Components/ModalInfo/ModalInfoTriseries';
import ModalVerticalVideo from '../../../../Components/ModalVerticalVideo/ModalVerticalVideo';
import ModalInfoBiseries from '../../../../Components/ModalInfo/ModalInfoBiseries';

import { logoBlanco } from '../../../../Shared/Images';

import './../../../../Shared/css/MisRutinas/ejercicioRutina.css';
import ModalInfoDropset from '../../../../Components/ModalInfo/ModalInfoDropset';


interface Props {
  orden: number;
  ejercicioProp: IEjercicioRutina;
  diaFromStorage: any;
  changeRutinas: boolean;
  setChangeRutinas: Dispatch<SetStateAction<boolean>>;
}

const EjercicioRutinaPorDia = ({ ejercicioProp, changeRutinas, setChangeRutinas, diaFromStorage, orden } : Props) => {

  const [isModalInfoBiseriesOpen, setIsModalInfoBiseriesOpen] = useState<boolean>(false);
  const [isModalInfoTriseriesOpen, setIsModalInfoTriseriesOpen] = useState<boolean>(false);
  const [currentVideoEjercicioSelected, setCurrentVideoEjercicioSelected] = useState<IEjercicioItems>();
  const [isReemplazosOpen, setIsReemplazosOpen] = useState(false);
  const [ejercicioSelected, setejercicioSelected] = useState<IEjercicioItems>();
  const [isSeriesOpen, setIsSeriesOpen] = useState(false);
  const [IsOpenModalVerticalVideo, setIsOpenModalVerticalVideo] = useState<boolean>(false)
  const [isModalInfoDropsetOpen, setIsModalInfoDropsetOpen] = useState<boolean>(false);

  const openReemplazoEjercicio = (ejercicio: IEjercicioItems) => {
    setIsReemplazosOpen(true);
    setejercicioSelected(ejercicio);
  };

  const openSerieEjercicio = (ejercicio: IEjercicioItems) => {
    setIsSeriesOpen(true);
    setejercicioSelected(ejercicio);
  };

  const handleOpenVerticalVideo = ( ejercicio : IEjercicioItems ) => {
    setejercicioSelected(ejercicio);
    setIsOpenModalVerticalVideo(true);
  }

  const handlePlayClick = (ejercicio: IEjercicioItems) => {
    if (ejercicio.orientacionEjercicio === 'H') {
      setCurrentVideoEjercicioSelected(ejercicio);
    } else {
      handleOpenVerticalVideo(ejercicio);
    }
  };

  return (
    <div>
      {/* Exercise Type Header (Biserie/Triserie) */}
      {ejercicioProp.tipo === 'Biserie' && (
        <div className="ejrut-type-header">
          <span className="ejrut-exercise-type">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
            </svg>
            {orden}. Biserie
          </span>
          <button className="ejrut-info-btn cursor-pointer" title='¿Biseries?' onClick={() => setIsModalInfoBiseriesOpen(true)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
          </button>
        </div>
      )}
      {ejercicioProp.tipo === 'Triserie' && (
        <div className="ejrut-type-header">
          <span className="ejrut-exercise-type">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
            </svg>
            {orden}. Triserie
          </span>
          <button className="ejrut-info-btn cursor-pointer" title='¿Triseries?' onClick={() => setIsModalInfoTriseriesOpen(true)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
          </button>
        </div>
      )}

      {ejercicioProp.ejercicioItems.map((ejercicio, i) => (
        <div key={`${ejercicio.fit4RutinaEjercicioID}-${i}`} className="ejrut-item">

          {/* Exercise number + Muscle group inline */}
          <div className="ejrut-meta-row">
            <span className="ejrut-exercise-number">
              {ejercicioProp.tipo === 'Biserie' || ejercicioProp.tipo === 'Triserie'
                ? 'Sub-ejercicio'
                : `Ejercicio ${orden}`}
            </span>
            <div className="ejrut-meta-right">
              {ejercicio.grupoMuscular && (
                <span className="ejrut-muscle-pill">{ejercicio.grupoMuscular}</span>
              )}
              {ejercicio.tipoEjercicio === 'D' && (
                <span className="ejrut-dropset-badge">
                  Dropset 
                  <button className="ml-1 flex items-center justify-center" title='¿Dropsets?' onClick={() => setIsModalInfoDropsetOpen(true)}>
                    <svg width="16" height="16" viewBox="0 0 25 25" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                    </svg>
                  </button>
                </span>
              )}
            </div>
          </div>
          <p className="ejrut-exercise-name">{ejercicio.ejercicio}</p>

          {/* Quick Stats */}
          <div className="ejrut-quick-stats">
            <div className="ejrut-stat">
              <span className="ejrut-stat-value">{ejercicio.numeroSeries}</span>
              <span className="ejrut-stat-label">Series</span>
            </div>
            <div className="ejrut-stat-divider" />
            <div className="ejrut-stat">
              <span className="ejrut-stat-value">{ejercicio.repeticiones}</span>
              <span className="ejrut-stat-label">Reps</span>
            </div>
          </div>

          {/* Video Thumbnail */}
          <div className="ejrut-video-container">
            {currentVideoEjercicioSelected === undefined ||
            currentVideoEjercicioSelected.fit4RutinaEjercicioID !==
              ejercicio.fit4RutinaEjercicioID ? (
              <div
                className="ejrut-video-thumbnail"
                onClick={() => handlePlayClick(ejercicio)}
              >
                {/* Modern play button overlay */}
                <div className="ejrut-play-overlay">
                  <div className="ejrut-play-btn">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFFFFF">
                      <path d="M8 5.14v14l11-7-11-7z"/>
                    </svg>
                  </div>
                </div>

                {ejercicio.portada != null ? (
                  <img
                    src={ejercicio.portada}
                    alt={ejercicio.ejercicio}
                    className="ejrut-video-img"
                  />
                ) : (
                  <div className="ejrut-video-placeholder">
                    <img src={logoBlanco} alt="" style={{ width: '50%' }} />
                  </div>
                )}
              </div>
            ) : (
              <ReactPlayer
                playing={
                  ejercicio.fit4RutinaEjercicioID ===
                  currentVideoEjercicioSelected.fit4RutinaEjercicioID
                }
                width={'100%'}
                height={'100%'}
                controls={true}
                url={ejercicio.ejercicioURL}
                style={{ borderRadius: '12px', overflow: 'hidden' }}
              />
            )}
          </div>

          {/* Action Buttons */}
          <div className="ejrut-actions">
            <button
              className="ejrut-action-btn ejrut-action-btn--series"
              onClick={() => openSerieEjercicio(ejercicio)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 4v16"/><path d="M18 4v16"/><path d="M6 12h12"/>
              </svg>
              Ver Series
            </button>
            {ejercicio.ejercicioReemplazo !== '' && (
              <button
                className="ejrut-action-btn ejrut-action-btn--replace"
                onClick={() => openReemplazoEjercicio(ejercicio)}
                disabled={diaFromStorage.estado === '2'}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
                  <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
                </svg>
                Cambiar
              </button>
            )}
          </div>

          {/* Separator between items in biserie/triserie */}
          {ejercicioProp.ejercicioItems.length > 1 && i < ejercicioProp.ejercicioItems.length - 1 && (
            <div className="ejrut-separator" />
          )}
        </div>
      ))}

      <Suspense fallback={<div />}>
        {isReemplazosOpen && (
          <Reemplazos
            isOpen={isReemplazosOpen}
            setIsOpen={setIsReemplazosOpen}
            ejercicioProp={ejercicioSelected}
            changeRutinas={changeRutinas}
            setChangeRutinas={setChangeRutinas}
          />
        )}
        {IsOpenModalVerticalVideo && (
          <ModalVerticalVideo
            isOpen={IsOpenModalVerticalVideo}
            setIsOpen={setIsOpenModalVerticalVideo}
            ejercicio={ejercicioSelected}
          />
        )}
        {isSeriesOpen && (
          <Series
            ejercicio={ejercicioSelected}
            isOpen={isSeriesOpen}
            setIsOpen={setIsSeriesOpen}
            estado={diaFromStorage.estado}
          />
        )}
        {isModalInfoBiseriesOpen && (
          <ModalInfoBiseries
            isOpen={isModalInfoBiseriesOpen}
            setIsOpen={setIsModalInfoBiseriesOpen}
          />
        )}
        {isModalInfoTriseriesOpen && (
          <ModalInfoTriseries
            isOpen={isModalInfoTriseriesOpen}
            setIsOpen={setIsModalInfoTriseriesOpen}
          />
        )}
        {isModalInfoDropsetOpen && (
          <ModalInfoDropset
            isOpen={isModalInfoDropsetOpen}
            setIsOpen={setIsModalInfoDropsetOpen}
          />
        )}
      </Suspense>
    </div>
  )
}

export default EjercicioRutinaPorDia
